import ButtonEditCustomer from 'AppointmentBox/CustomerTab/ButtonEditCustomer';
import IconPlus from 'assets/Icons/icon-plus';
import CustomerSearchInput from 'CalendarFilter/CustomerSearch/CustomerSearchInput';
import Box from 'components/Box';
import Text from 'components/Text';
import React from 'react';
import styled from 'styled-components';
import { ICustomerUI } from 'types/customer';
import { formatCurrency } from 'utils/formatCurrency';
import { formatPhone, maskPhone } from 'utils/formatPhone';
import AddCustomer from 'widgets/AddCustomer';

type CustomerSectionProps = {
  currentCustomer?: ICustomerUI;
  handleChangeCustomer: (customer?: ICustomerUI | null) => void;
};

const CustomerSection = ({ currentCustomer, handleChangeCustomer }: CustomerSectionProps) => {

  const addCustomer = async () => {
    const customer = await AddCustomer.add({phoneNumber: currentCustomer?.phone});
    handleChangeCustomer(customer);
  };

  return (
    <CustomerContainer>
      <Box width={'100%'} display='flex' alignItems='center' gap='2'>
        <CustomerSearchInput
          value={currentCustomer}
          v2NewApt
          preventUnknown
          autoOpenAddWhenNotFound
          v2
          onChange={(customer) => handleChangeCustomer(customer)} />
          <button onClick={addCustomer}>
            <IconPlus/>
          </button>
      </Box>
      <Box width={'100%'} display='flex' alignItems='center' justifyContent='space-between'>
        <Box display='flex' gap='2' alignItems='center'>
          <Text variant='H7'>
            {currentCustomer?.name}
          </Text>
          <Text variant='H7'>
            {maskPhone(currentCustomer?.phone ?? '')}
          </Text>
          <Text variant='H7' color='#F05326'>
            {currentCustomer?.point ?? 0} points = {formatCurrency((currentCustomer?.point ?? 0) / 10)}
          </Text>
        </Box>

        <ButtonEditCustomer renderButton={({ onClick, iconSrc }) => (
          <button type='button' className='btn-edit-custom' onClick={onClick}>
            <img src={iconSrc} alt="IconEdit" className='icon-edit' />
            <span className='text-value'>
              Edit customer
            </span>
          </button>
        )
        } onSelect={(customer) => handleChangeCustomer(customer)} customerId={Number(currentCustomer?.id)} />
      </Box>
    </CustomerContainer>
  );
};

const CustomerContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
  padding: 8px;
  border-radius: 8px;
  width: 100%;

  display: flex;
  align-items: center;
  gap: 8px;
  span {
    &.text-label {
      color: #1D2129;
      font-size: 16px;
    }
    &.text-value {
      color: #148CF1;
    }
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    text-transform: capitalize;
  }
  .btn-edit-custom {
    width: unset;
    gap: 8px;
    display: flex;
    align-items: center;
    .icon-edit {
      width: 28px;
      height: 28px;
    }
  }
`;

export default CustomerSection;
